// header search
(function() {
  const mq = window.matchMedia('(max-width: 1023px)');
  if (mq.matches) {
    const headerSearch = document.querySelector('.header__search');
    if (headerSearch) {
      headerSearch.remove();
    }
  } else {
    const headerSearchMobile = document.querySelector('.header-drawer__search');
    if (headerSearchMobile) {
      headerSearchMobile.remove();
    }
  }
})();

